import { Box } from '@material-ui/core'
import MuiDrawer, { DrawerProps as Props } from '@material-ui/core/Drawer'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Color from '../base/Color'
import Typography from '../base/Typography'
import MenuButton, { MenuButtonsProps } from '../button/MenuButton'
import Icons from '../icons/Icons'

export type SideMenuProps = {
  toggleClick(open: boolean): void
  isOpen: boolean
  logOut(): void
} & Props &
  MenuButtonsProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
      '& .MuiBackdrop-root': {
        background: 'transparent',
        paddingTop: theme.spacing(10)
      }
    },
    paper: {
      justifyContent: 'space-between',
      top: 0,
      flex: '1 0 auto',
      height: '100%',
      display: 'flex',
      outline: 0,
      zIndex: 1200,
      position: 'fixed',
      overflowY: 'auto',
      flexDirection: 'column'
    },
    logOut: {
      backgroundColor: Color.primary[400],
      padding: theme.spacing(2),
      color: theme.palette.primary.main,
      '&:hover': {
        cursor: 'pointer'
      }
    }
  })
)

const SideNav: React.FC<SideMenuProps> = (props) => {
  const classes = useStyles()
  const {
    toggleClick,
    menus,
    isOpen,
    onClick,
    urlOnClick,
    children,
    activeRoute,
    logOut,
    ...rest
  } = props
  return (
    <Box>
      {children}
      <MuiDrawer
        elevation={2}
        classes={{ paper: classes.paper }}
        className={classes.root}
        open={isOpen}
        onClose={() => toggleClick(isOpen)}
        {...rest}
      >
        <MenuButton
          menus={menus}
          onClick={onClick}
          urlOnClick={urlOnClick}
          activeRoute={activeRoute}
        />
        <Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className={classes.logOut}
            onClick={logOut}
          >
            <Icons iconName="LogoutIcon" />
            <Box ml={1}>
              <Typography variant="subtitle1" children="Logout" />
            </Box>
          </Box>
        </Box>
      </MuiDrawer>
    </Box>
  )
}

export default SideNav
